import { render, staticRenderFns } from "./BFilterSelect.vue?vue&type=template&id=53766100"
import script from "./BFilterSelect.vue?vue&type=script&lang=js"
export * from "./BFilterSelect.vue?vue&type=script&lang=js"
import style0 from "./BFilterSelect.vue?vue&type=style&index=0&id=53766100&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports